import ko from 'knockout';
import _ from 'lodash';
import { filterColumnSupportsListValues } from './filterColumnSupportsListValues';

//Update the list of filter operators on the passed in filter. This is used for the dropdowns in the UI.
export function updateFilterOperators(filter, listValueColumns) {

    if (_.isNullOrUndefined(filter))
        return;

    var supportsListValues = filterColumnSupportsListValues(filter, listValueColumns);

    var dataType = "string";
    if (filter.column && filter.column.dataTypeString) {
        dataType = ko.isObservable(filter.column.dataTypeString) ? filter.column.dataTypeString() : filter.column.dataTypeString;
        dataType = dataType !== "string" ? "number" : "string";
    }

    var operators = [
        { text: "Equal to", value: "eq", dataTypes: ["string", "number", "date"] },
        { text: "Not equal to", value: "ne", dataTypes: ["string", "number", "date"] },
        { text: "Greater than or equal to", value: "ge", dataTypes: ["number", "date"] },
        { text: "Greater than", value: "gt", dataTypes: ["number", "date"] },
        { text: "Less than or equal to", value: "le", dataTypes: ["number", "date"] },
        { text: "Less than", value: "lt", dataTypes: ["number", "date"] },
        { text: "Starts with", value: "startswith", dataTypes: ["string"] },
        { text: "Ends with", value: "endswith", dataTypes: ["string"] },
        { text: "Contains", value: "contains", dataTypes: ["string"] },
        { text: "Does Not Contain", value: "doesnotcontain", dataTypes: ["string"] },
        { text: "List of values", value: "list", dataTypes: ["list"] },
        { text: "List of values (negative)", value: "nlist", dataTypes: ["nlist"] }
    ];

    operators = _.filter(operators, function (op) {
        if (supportsListValues && (op.dataTypes[0] === "list" || op.dataTypes[0] === "nlist"))
            return true;
        return _.includes(op.dataTypes, dataType);
    });

    filter.filterOperators(operators);
};
